// extracted by mini-css-extract-plugin
export default {"hidden":"downloadDeliveryNoteModal_hidden__l4Nih"};